import { render, staticRenderFns } from "./BlockError.vue?vue&type=template&id=5cbb1507&scoped=true&"
import script from "./BlockError.vue?vue&type=script&lang=js&"
export * from "./BlockError.vue?vue&type=script&lang=js&"
import style0 from "./BlockError.vue?vue&type=style&index=0&id=5cbb1507&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb1507",
  null
  
)

export default component.exports